import List from '@mui/material/List'
import { styled } from '@mui/material/styles'

export const KNBulletList = styled(List)({
  '&': {
    listStyleType: 'disc',
    listStylePosition: 'inside',
    padding: 0,
  },
  '& .MuiListItem-root': {
    display: 'list-item',
    padding: 0,
  },
})
